import React from 'react'
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { parseDate, formatDate, initModifiers, modifiersStyles } from '../helpers/date-format'
import dateFnsFormat from 'date-fns/format';

// I chose react-day-picker as my date picker component because it is highly customizable and only 9KB gzipped.
// setToday is the setter function that comes from App.js and we use it to trigger the second useEffect inside of App.js (change of day -> new events!)

export default function DayPicker(props) {
  const FORMAT = "EEEE, MMMM d"
  const modifiers = initModifiers(props)

  return (
    <DayPickerInput
      dayPickerProps={{
        month: new Date(),
        modifiers: modifiers,
        modifiersStyles: modifiersStyles,
        showOutsideDays: true,
      }}
      onDayChange={day => day && props.setToday(day.toLocaleDateString())}
      formatDate={formatDate}
      parseDate={parseDate}
      format={FORMAT}
      placeholder={`${dateFnsFormat(new Date(), FORMAT)}`}
  />
  )
}